import React, { memo } from "react";
import styled from "@emotion/styled";
import { useSelector } from "react-redux";
import { DisplayCard } from "./DisplayCard";
import { TotalCards } from "./TotalCards";
import { TotalPayout } from "./TotalPayout";

const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  background-color: transparent;
  border-spacing: 0;
`;

const Row = styled.tr`
  border: 1px solid #d0d0d0;
`;

const Th = styled.th`
  text-align: center;
  padding: 6px;
  font-size: 11px;
  background: #fff;
  color: #000;
  font-weight: 700;
`;

const View = memo(({ children }) => {
  const cards = useSelector((state) => state.Cart.cart.cards);
  const cardToDisplay = [];

  cards.forEach((card, i) => {
    cardToDisplay.push(<DisplayCard key={i} card={card} index={i} />);
  });

  if (!cards.length) return null;

  return (
    <Container>
      <Table>
        <thead>
          <Row>
            <Th>Merchant</Th>
            <Th>Card Number</Th>
            <Th>Pin</Th>
            <Th>RefID (Optional)</Th>
            <Th>Balance</Th>
            <Th>Sell %</Th>
            <Th>Sell Price</Th>
            <Th>Submission Type</Th>
          </Row>
        </thead>
        <tbody>{cardToDisplay}</tbody>
      </Table>
      <TotalCards total={cards.length} />
      <TotalPayout cards={cards} />
      {children}
    </Container>
  );
});

export { View };
